// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_list-module__container--2TyVE","item":"notification_list-module__item--1utPZ","empty":"notification_list-module__empty--3491s"};